import { render, staticRenderFns } from "./ModalCard.vue?vue&type=template&id=bb118cf0&scoped=true"
import script from "./ModalCard.vue?vue&type=script&lang=js"
export * from "./ModalCard.vue?vue&type=script&lang=js"
import style0 from "./ModalCard.vue?vue&type=style&index=0&id=bb118cf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb118cf0",
  null
  
)

export default component.exports